const RequirementsMatch = {
  Role: 'role',
  RoleExperience: 'roleExperience',
  MustHaveSkills: 'allMustHaveSkills',
  RemotePolicyAndLocation: 'remotePolicyAndLocation',
  VisaRequirements: 'visaRequirements',
  EmploymentType: 'employmentType',
}

Object.freeze(RequirementsMatch)

export { RequirementsMatch }

export const workplacePolicyTypeMap = {
  HYBRID: 'Hybrid',
  REMOTE: '100% remote',
  OFFICE: 'Office-based',
}

export const remunerationPeriodMap = {
  MONTH: 'per month',
  YEAR: 'per year',
}

export const employmentTypeMap = {
  CONTRACT: 'Contract',
  PERMANENT: 'Permanent contract',
}

export const authStatusMap = {
  CITIZEN: 'citizen/passport holder',
  PERMANENT_RESIDENT: 'permanent resident',
  WORK_PERMIT: 'work permit/visa holder',
}
